import {
  ScheduledBreakFormItemType,
  ShiftAreaSessionFormItemType,
} from '@/types/shiftSessionsForm';
import { ScheduledBreak } from '../../api/v1';

export type ShiftFormV2Type = {
  locationId: number | null;
  requiresApproval: boolean;
  scheduleId: number;
  employeeId: number | null;
  jobRoleId: number | null;
  tags: number[];
  startsAt: Date | null;
  endsAt: Date | null;
  showEndTime: boolean;
  showJobRole: boolean;
  published: boolean;
  scheduledBreaks: ScheduledBreak[];
  shiftAreaSessions: ShiftAreaSessionFormItemType[];
  notes: string;
};

export enum ShiftFormTabEnum {
  ShiftDetails = 'ShiftDetails',
  Advanced = 'Advanced',
}

export enum ShiftSessionTypeEnum {
  Break = 'Break',
  Area = 'Area',
}

export type ShiftSessionFormType =
  | {
      type: ShiftSessionTypeEnum.Break;
      form: ScheduledBreakFormItemType;
    }
  | {
      type: ShiftSessionTypeEnum.Area;
      form: ShiftAreaSessionFormItemType;
    };
